<template>
  <div class="children-multiselect">
    <children-box
      :children="data.children"
      label="Klienci"
      :selected="false"
    />
    <children-box
      :children="data.children"
      label="Lista uczestników"
      :selected="true"
    />
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

import {
  computed, onMounted, reactive, watch,
} from 'vue';
import store from '@/store';
import { urlBuilder } from '../../plugins/helpers';
import ChildrenBox from './children-box.vue';

export default {
  name: 'children-multiselect',
  components: { ChildrenBox },
  emits: ['selected-children'],
  props: {
    trainerId: Number,
    selectedChildren: Array,
  },
  setup(props, { emit }) {
    const data = reactive({
      children: [],
      downloadedData: [],
    });

    function addSelectedField() {
      data.children = data.downloadedData.map((child) => ({ ...child, selected: false }));
    }

    const isAdmin = computed(() => store.getters.isAdmin);

    async function getChildren() {
      if (isAdmin.value) {
        data.downloadedData = (await axios.get(
          urlBuilder('/clients/'),
        )).data;
      } else {
        data.downloadedData = (await axios.get(
          urlBuilder(`/trainer-clients/${props.trainerId}/`),
        )).data;
      }
      addSelectedField();
    }

    onMounted(async () => {
      await getChildren();
    });

    watch(() => props.trainerId, async () => {
      await getChildren();
    });

    function getSelectedChildren(children) {
      return children.reduce((filtered, child) => {
        if (child.selected) filtered.push(child.id);
        return filtered;
      }, []);
    }

    watch(() => _.cloneDeep(data.children), () => {
      emit('selected-children', getSelectedChildren(data.children));
    });

    watch(() => _.cloneDeep(data.downloadedData), async () => {
      let children = _.cloneDeep(data.children);
      if (props.selectedChildren.length) {
        children = await Promise.all(data.children.map((child) => {
          const newChild = child;
          if (props.selectedChildren.includes(newChild.id)) {
            newChild.selected = true;
          }
          return newChild;
        }));
      }
      emit('selected-children', getSelectedChildren(children));
    });

    watch(() => props.selectedChildren, () => {
      if (props.selectedChildren.length) {
        data.children = data.children.map((child) => {
          const newChild = child;
          if (props.selectedChildren.includes(newChild.id)) {
            newChild.selected = true;
          }
          return newChild;
        });
        emit('selected-children', getSelectedChildren(data.children));
      }
    });

    return {
      data,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';
.children-multiselect {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 20px;
  width: 100%;
}
</style>
